import * as vp from 'vopay';

type ChangePasswordRows = {
  label: vp.ChangePasswordLabel;
  id: vp.ChangePasswordId;
};

const buildPermissionRows = (): ChangePasswordRows[] => [
  {
    label: vp.ChangePasswordLabel.NewPassword,
    id: vp.ChangePasswordId.NewPassword,
  },
];

export default buildPermissionRows;
